<div
  id="shopping-cart-dropdown"
  fxLayout="column"
  fxLayoutAlign="space-between center"
>
  <!-- <button mat-icon-button class="close" mat-dialog-close>
    <jam-icon name="close" *ngIf="options && options.isDialog"></jam-icon>
  </button> -->
  <div class="order-list" fxFlex="50">
    <!-- <h3 *ngIf="orders.length > 0">موارد اضافه شده به سبد خرید شما:</h3> -->
    <div
      style="text-align: center"
      class="not-found"
      *ngIf="orders.length === 0"
    >
      <div class="not-found">
        <img src="assets/image/empty-box-2.svg" alt="not-found">
        <div class="not-found-text">هیچ سفارشی یافت نشد!</div>
        <button mat-button mat-raised-button class="mt-3" color="primary" (click)="closeShoppingCard.emit()">ثبت سفارش</button>
      </div>
    </div>
    <shared-order
      style="width: 100%"
      (change)="getTotalPrice()"
      (delete)="deleteOrder(i)"
      *ngFor="let order of orders || []; index as i"
      [orderObject]="order"
      [actionsOn]="true"
      class="shared-order"
    />
  </div>
  <div class="actions" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="total-price">
      <span>جمع سبد : {{ totalPrice | irc : "T" | digitsEnToFa }}</span>
    </div>
    <button
      class="continue"
      color="warn"
      mat-flat-button
      [routerLink]="['basket']"
      (click)="goToBasket()"
      [disabled]="orders.length === 0"
    >
      ادامه خرید
      <jam-icon name="chevron-left"></jam-icon>
    </button>
  </div>
</div>
